export default __webpack_public_path__ + "static/media/abbvie.823bf3ee.svg";